export default __webpack_public_path__ + "static/media/dollar.d4a9bb64.svg";